import Navbar from "./Composant/Navbar/navbar";
import HomePage from "./Section/1_Home/homePage";
import AboutSection from "./Section/2_A_propos/a_propos";
import ServiceSection from "./Section/3_Services/services";
import SkillSection from "./Section/4_Skills/skills";
import PortfolioSection from "./Section/5_Portfolio/portfolio";
import ContactSection from "./Section/6_Contact/contact";

function Base() {
  return (
    <>
      <Navbar></Navbar>
      <HomePage></HomePage>
      <AboutSection></AboutSection>
      <ServiceSection></ServiceSection>
      <SkillSection></SkillSection>
      <PortfolioSection></PortfolioSection>
      <ContactSection></ContactSection>
    </>
  );
}

export default Base;
